import React from 'react'
import loadable from '@loadable/component'

import OrderItemSkeleton from './OrderItemSkeleton/OrderItemSkeleton'


const fallback = <OrderItemSkeleton />

export * from './util'

export { default as OrderItemsContainer } from './OrderItemsContainer/OrderItemsContainer'
export { default as OrderBillItem } from './OrderBillItem/OrderBillItem'
export { default as GiftCardOrderItem } from './GiftCardOrderItem/GiftCardOrderItem'
export { default as GiftSubscriptionOrderItem } from './GiftSubscriptionOrderItem/GiftSubscriptionOrderItem'
export { default as RedeemedGiftSubscriptionOrderItem } from './RedeemedGiftSubscriptionOrderItem/RedeemedGiftSubscriptionOrderItem'
export { default as ProductOrderItem } from './ProductOrderItem/ProductOrderItem'
export { default as QueueProductOrderItem } from './QueueProductOrderItem/QueueProductOrderItem'
export { default as SubscriptionOrderItem } from './SubscriptionOrderItem/SubscriptionOrderItem'
export { default as CaseSubscriptionOrderItem } from './CaseSubscriptionOrderItem/CaseSubscriptionOrderItem'
export { default as CandleSubscriptionOrderItem } from './CandleSubscriptionOrderItem/CandleSubscriptionOrderItem'
export { default as SubscriptionBanner } from './SubscriptionBanner/SubscriptionBanner'
export { default as GiftSubscriptionBanner } from './GiftSubscriptionBanner/GiftSubscriptionBanner'
export { default as GiftSubscriptionOfferOrderItem } from './GiftSubscriptionOfferOrderItem/GiftSubscriptionOfferOrderItem'

export const DriftOrderItem = loadable(() => import('./DriftOrderItem/DriftOrderItem'), { fallback })

export const DriftSubscriptionOrderItem = loadable( () => import('./DriftSubscriptionOrderItem/DriftSubscriptionOrderItem'), { fallback })

export const LimitedDropOrderItem = loadable(
  () => import('./LimitedDropOrderItem/LimitedDropOrderItem'),
  { fallback: <OrderItemSkeleton bgColor="gray-20" /> }
)
